import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import EnlisteeSearchResultsMessage from '../molecules/EnlisteeSearchResultsMessage';

class EnlisteeSearchResults extends Component {
  render() {
    if ( this.props.loading ) {
      return (
        <p>Loading...</p>
      )
    } else if ( this.props.results.length > 0 ) {
      return (
        <div className="EnlisteeSearchResults">
          <ul>
            {this.props.results.map( enlistee => {
              return (
                <li key={enlistee.node.nid}>
                  <Link to={'/location?location=' + enlistee.node.plaque_nid}>
                    <span>{enlistee.node.given_name} {enlistee.node.family_name}</span>
                    <span>{enlistee.node.plaque_name}</span>
                  </Link>
                </li>
              )
            } )}
          </ul>
          <EnlisteeSearchResultsMessage pagination={this.props.pagination}/>
        </div>
      )
    } else if ( this.props.term.length === 0 ) {
      return (
        <p>Enter a search term to see enlistees.</p>
      )
    } else if ( this.props.error ) {
      return (
        <p>We seem to be having an error connecting to our API. Please try again later.</p>
      )
    } else {
      return (
        <p>Sorry but we can't seem to find any results for that search.</p>
      )
    }

  }
}

export default EnlisteeSearchResults;